var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 73,
    viewBox: "0 0 80 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5437,
    cy: 41.3271,
    r: 30.9436,
    fill: "#6DA4E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.2271 11.6764C73.7863 11.1056 72.9675 11.0003 72.3967 11.4437L63.642 18.2218C63.072 18.6618 62.9675 19.4823 63.4092 20.0514C63.8523 20.6265 64.678 20.7223 65.2388 20.2842L73.9935 13.506C74.5635 13.066 74.668 12.2455 74.2271 11.6764Z",
    fill: "#FB8B0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.164 26.9661C79.1896 26.2454 78.6271 25.6411 77.9047 25.6174L66.8393 25.2365C66.1198 25.2108 65.5151 25.7751 65.4911 26.4951C65.4644 27.2205 66.0384 27.822 66.7497 27.8433L77.8151 28.2242C78.5347 28.2499 79.1394 27.6856 79.164 26.9661Z",
    fill: "#FB8B0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3999 1.28874C60.7059 1.09235 59.9852 1.49497 59.7903 2.19097L56.7881 12.8481C56.5919 13.5409 56.9962 14.2625 57.6898 14.457C58.3881 14.6555 59.1088 14.2411 59.2987 13.5553L62.3009 2.89812C62.4971 2.20535 62.0928 1.48376 61.3999 1.28874Z",
    fill: "#FB8B0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4015 52.2126C25.6735 52.4633 26.0832 52.4684 26.3612 52.2185C32.4252 46.7502 37.953 41.0151 44.5485 35.2277C45.1176 34.7282 45.4567 34.0301 45.504 33.2602C45.6496 30.8675 42.9082 29.3007 41.0452 30.9023C35.4024 35.7459 30.7108 40.1391 26.3348 44.6798C25.4748 43.787 24.3244 42.5097 22.9048 40.8706C21.8073 39.6039 19.8266 39.3848 18.4942 40.7527C17.3239 41.9532 17.2681 43.8804 18.366 45.1409C21.016 48.1806 22.6797 49.6977 25.4015 52.2126Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/successful.f7ca0744b60b819f26a236918a82ebd1.svg";
export { ForwardRef as ReactComponent };